import { action } from 'satcheljs';

export const updateSelectedCalendarsInStore = action(
    'UPDATE_SELECTED_CALENDARS_IN_STORE',
    (calendarIds: string[], primarySmtpAddress: string) => ({ calendarIds, primarySmtpAddress })
);

export const addSelectedCalendarInStore = action(
    'ADD_SELECTED_CALENDAR_IN_STORE',
    (calendarId: string, primarySmtpAddress: string) => ({ calendarId, primarySmtpAddress })
);
